import { useTranslation } from 'react-i18next';
import { startTelemed } from 'utils';
import { makeid } from 'utils/helpers/makeid';

interface Props {
  sendAppointmentRequest: () => void;
  appointmentsFlagActive: boolean;
}

export const useRequestButtons = ({
  sendAppointmentRequest,
  appointmentsFlagActive,
}: Props) => {
  const { t } = useTranslation();

  const requestButtons = [
    {
      id: makeid(5),
      render: true,
      label: appointmentsFlagActive
        ? t('labels.requestNextAppointment')
        : t('labels.nextAppointmentRequested'),
      handleClick: () => sendAppointmentRequest(),
      disabled: !appointmentsFlagActive,
    },
    {
      id: makeid(5),
      render: true,
      label: t('labels.startTelemed'),
      handleClick: () => startTelemed(),
    },
  ].filter(({ render }) => render);

  return requestButtons;
};
